__webpack_require__.p = "https://fbusinesscenter.com/cross-user-authorization/frontend/";